import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import ReactPlayer from 'react-player';
import ViewImageAndText from '../../components/ViewImageAndText';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';

const InstituteDashboardStudentList = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    let instituteMasterId = localStorage.getItem("instituteMasterId")

    const [activeTab, setActiveTab] = useState("active");

    const [activeList, setActiveList] = useState([]);
    const [inActiveList, setInActiveList] = useState([]);

    const [startIndexActive, setStartIndexActive] = useState(null);
    const [startIndexInActive, setStartIndexInActive] = useState(null);

    const [currPageActive, setCurrPageActive] = useState(1);
    const [currPageInActive, setCurrPageInActive] = useState(1);

    const [itemsPerPageActive, setItemsPerPageActive] = useState(10);
    const [itemsPerPageInActive, setItemsPerPageInActive] = useState(10);

    const [displayedDataActive, setDisplayedDataActive] = useState([]);
    const [displayedDataInActive, setDisplayedDataInActive] = useState([]);

    const [totalPagesActive, setTotalPagesActive] = useState(0);
    const [totalPagesInActive, setTotalPagesInActive] = useState(0);



    const [activeStudentIdSort, setActiveStudentIdSort] = useState(null);
    const [activeRegIdSort, setActiveRegIdSort] = useState(null);
    const [activeNameSort, setActiveNameSort] = useState(null);
    const [activeGenderSort, setActiveGenderSort] = useState(null);

    const [inActiveStudentIdSort, setInActiveStudentIdSort] = useState(null);
    const [inActiveRegIdSort, setInActiveRegIdSort] = useState(null);
    const [inActiveNameSort, setInActiveNameSort] = useState(null);
    const [inActiveGenderSort, setInActiveGenderSort] = useState(null);


    const [searchValueActive, setSearchValueActive] = useState(null);
    const [searchValueInActive, setSearchValueInActive] = useState(null);

    const searchKeys = ["std_id", "regis_no", "studentName", "gender", "primaryContact", "email"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };


    useEffect(() => {
        getActiveStudentList();
        getInActiveStudentList();
    }, [])

    const getApiUrlActive = () => {
        return `/get-active-students?instituteMasterId=${instituteMasterId}`;
    }

    const getApiUrlInActive = () => {
        return `/get-deactive-students?instituteMasterId=${instituteMasterId}`;
    }


    const getActiveStudentList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlActive();
            const response = await authorizedAxiosCommon.get(apiUrl);
            setActiveList(response.data.result);
        } catch (error) {
            setActiveList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getInActiveStudentList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlInActive();
            const response = await authorizedAxiosCommon.get(apiUrl);
            setInActiveList(response.data.result);
        } catch (error) {
            setInActiveList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        if (searchValueActive === '' && searchValueActive !== null) {
            setCurrPageActive(1);
            getActiveStudentList();
        }
    }, [searchValueActive]);

    useEffect(() => {
        if (searchValueInActive === '' && searchValueInActive !== null) {
            setCurrPageInActive(1);
            getInActiveStudentList();
        }
    }, [searchValueInActive]);



    const handleEmptySearchActive = (e) => {
        setSearchValueActive(e.target.value);
    }

    const handleEmptySearchInActive = (e) => {
        setSearchValueInActive(e.target.value);
    }


    const handleSearchActive = async () => {
        if (searchValueActive !== null) {
            setCurrPageActive(1);
            setActiveList(await searchArray("C", getApiUrlActive(), searchKeys, searchValueActive.trim()));
        }
    }

    const handleSearchInActive = async () => {
        if (searchValueInActive !== null) {
            setCurrPageInActive(1);
            setInActiveList(await searchArray("C", getApiUrlInActive(), searchKeys, searchValueInActive.trim()));
        }
    }


    useEffect(() => {
        setTotalPagesActive(Math.ceil(activeList.length / itemsPerPageActive));
        const startIndexActive = (currPageActive - 1) * itemsPerPageActive;
        let endIndexPdf = startIndexActive + itemsPerPageActive;

        if (endIndexPdf > activeList.length) {
            endIndexPdf = activeList.length;
        }
        setStartIndexActive(startIndexActive);
        setDisplayedDataActive(activeList.slice(startIndexActive, endIndexPdf));
    }, [activeList, currPageActive, itemsPerPageActive]);

    useEffect(() => {
        setTotalPagesInActive(Math.ceil(inActiveList.length / itemsPerPageInActive));
        const startIndexInActive = (currPageInActive - 1) * itemsPerPageInActive;
        let endIndexReference = startIndexInActive + itemsPerPageInActive;

        if (endIndexReference > inActiveList.length) {
            endIndexReference = inActiveList.length;
        }
        setStartIndexInActive(startIndexInActive);
        setDisplayedDataInActive(inActiveList.slice(startIndexInActive, endIndexReference));
    }, [inActiveList, currPageInActive, itemsPerPageInActive])



    useEffect(() => {
        if (activeStudentIdSort == true || activeStudentIdSort == false) {
            setActiveRegIdSort(null);
            setActiveNameSort(null);
            setActiveGenderSort(null);
        }
    }, [activeStudentIdSort])

    useEffect(() => {
        if (activeRegIdSort == true || activeRegIdSort == false) {
            setActiveStudentIdSort(null);
            setActiveNameSort(null);
            setActiveGenderSort(null);
        }
    }, [activeRegIdSort])

    useEffect(() => {
        if (activeNameSort == true || activeNameSort == false) {
            setActiveStudentIdSort(null);
            setActiveRegIdSort(null);
            setActiveGenderSort(null);
        }
    }, [activeNameSort])

    useEffect(() => {
        if (activeGenderSort == true || activeGenderSort == false) {
            setActiveStudentIdSort(null);
            setActiveRegIdSort(null);
            setActiveNameSort(null);
        }
    }, [activeGenderSort])



    useEffect(() => {
        if (inActiveStudentIdSort == true || inActiveStudentIdSort == false) {
            setInActiveRegIdSort(null);
            setInActiveNameSort(null);
            setInActiveGenderSort(null);
        }
    }, [inActiveStudentIdSort])

    useEffect(() => {
        if (inActiveRegIdSort == true || inActiveRegIdSort == false) {
            setInActiveStudentIdSort(null);
            setInActiveNameSort(null);
            setInActiveGenderSort(null);
        }
    }, [inActiveRegIdSort])

    useEffect(() => {
        if (inActiveNameSort == true || inActiveNameSort == false) {
            setInActiveStudentIdSort(null);
            setInActiveRegIdSort(null);
            setInActiveGenderSort(null);
        }
    }, [inActiveNameSort])

    useEffect(() => {
        if (inActiveGenderSort == true || inActiveGenderSort == false) {
            setInActiveStudentIdSort(null);
            setInActiveRegIdSort(null);
            setInActiveNameSort(null);
        }
    }, [inActiveGenderSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Student List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Student List</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <button className={`${activeTab === "active" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("active")} >Active List</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${activeTab === "inactive" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("inactive")} >Inactive List</button>
                                                            </div>
                                                        </div>

                                                        {activeTab == "active" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueActive}
                                                                        onChange={handleEmptySearchActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Std Id
                                                                                <SortIcon sortState={activeStudentIdSort} setSortState={setActiveStudentIdSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"std_id"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Reg Id
                                                                                <SortIcon sortState={activeRegIdSort} setSortState={setActiveRegIdSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"regis_no"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Name
                                                                                <SortIcon sortState={activeNameSort} setSortState={setActiveNameSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"studentName"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Gender
                                                                                <SortIcon sortState={activeGenderSort} setSortState={setActiveGenderSort} setData={setActiveList} setCurrPage={setCurrPageActive} sortingPath={"gender"} />
                                                                            </th>
                                                                            <th scope="col">Phone No</th>
                                                                            <th scope="col">Email</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataActive?.length > 0 ?
                                                                                displayedDataActive?.map((std, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexActive + index + 1}</th>
                                                                                            <td>{std.std_id}</td>
                                                                                            <td>{std.regis_no}</td>
                                                                                            <td>{std.studentName}</td>
                                                                                            <td>{std.gender}</td>
                                                                                            <td>{std.primaryContact}</td>
                                                                                            <td>{std.email}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>

                                                                <Pagination currPage={currPageActive} setCurrPage={setCurrPageActive} totalPages={totalPagesActive} itemsPerPage={itemsPerPageActive} setItemsPerPage={setItemsPerPageActive} totalItem={activeList.length} />
                                                            </div>}

                                                        {activeTab == "inactive" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueInActive}
                                                                        onChange={handleEmptySearchInActive}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchInActive();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchInActive}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope='col'>
                                                                                Std Id
                                                                                <SortIcon sortState={inActiveStudentIdSort} setSortState={setInActiveStudentIdSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"std_id"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Reg Id
                                                                                <SortIcon sortState={inActiveRegIdSort} setSortState={setInActiveRegIdSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"regis_no"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Name
                                                                                <SortIcon sortState={inActiveNameSort} setSortState={setInActiveNameSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"studentName"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Gender
                                                                                <SortIcon sortState={inActiveGenderSort} setSortState={setInActiveGenderSort} setData={setInActiveList} setCurrPage={setCurrPageInActive} sortingPath={"gender"} />
                                                                            </th>
                                                                            <th scope="col">Phone No</th>
                                                                            <th scope="col">Email</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataInActive?.length > 0 ?
                                                                                displayedDataInActive?.map((std, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexInActive + index + 1}</th>
                                                                                            <td>{std.std_id}</td>
                                                                                            <td>{std.regis_no}</td>
                                                                                            <td>{std.studentName}</td>
                                                                                            <td>{std.gender}</td>
                                                                                            <td>{std.primaryContact}</td>
                                                                                            <td>{std.email}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageInActive} setCurrPage={setCurrPageInActive} totalPages={totalPagesInActive} itemsPerPage={itemsPerPageInActive} setItemsPerPage={setItemsPerPageInActive} totalItem={inActiveList.length} />
                                                            </div>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
};

export default InstituteDashboardStudentList;